export default __webpack_public_path__ + "static/media/profil.fe0e751c.png";